import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import { AssignmentModal } from "/js/assignments/modal";

class LessonCardView extends Backbone.View {
  initialize(attributes) {
    this.leftColTemplate = _.template(this.$("#left-col-template").html());
    this.rightColTemplate = _.template(this.$("#right-col-template").html());
    this.$leftCol = this.$(".left-col");
    this.$rightCol = this.$(".right-col");

    this.$el.on("hidden.bs.modal", () => {
      if (attributes.on_close) attributes.on_close();
    });

    this.$el.on("shown.bs.modal", () => {
      $.get(Base.get_route("lesson_json", attributes.lesson_id), (response) => {
        this.data = response;
        this.render();
      });
    });

    this.$el.modal();
  }

  get events() {
    return {
      "click [data-assignment-id]": "onAssignmentClicked",
    };
  }

  onAssignmentClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    new AssignmentModal().showWithAssignment(
      $(e.currentTarget).attr("data-assignment-id")
    );
  }

  render() {
    this.$(".subject-name").text(this.data.info.title);
    this.$leftCol.html(this.leftColTemplate(this.data));
    this.$rightCol.html(this.rightColTemplate(this.data)).linkify({
      target: "_blank",
    });
  }
}

class LessonCard extends Backbone.Model {
  initialize(lesson_id, on_close) {
    Base.get_template("lesson_card", (html) => {
      this.view = new LessonCardView({
        lesson_id: lesson_id,
        el: $(html),
        on_close: on_close,
      });
    });
  }
}

export { LessonCard };
